<template>
  <el-container id="app" direction="vertical">
    <cheader></cheader>
    <div class="bg_item">
      <div class="item_left"></div>
      <div class="item_right"></div>
      <router-view />
      <cfooter></cfooter>
    </div>
  </el-container>
</template>

<style>
@import "../static/font/font.css";
#app {
  /* background: url("../static/image/bg.png") center bottom 100%;
   */
   background: #DFDFDF;
}
#app {
  font-family: "jxzk";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* width: 1920px; */
  height: 1700px;
  /* border:2px solid red; */
  display: flex;
  flex-direction: column;
  justify-content: top;
  position: relative;
}
body::-webkit-scrollbar {
    width:0px;
    height:0px;
}
.bg_item{
  /* position: absolute; */
  /* border: 1px solid green; */
  /* top: 23.5%;
  left: 28.5%; */
}
.item_left{
  width: 222px;
  height: 151px;
  background: url("../static/image/picl.png");
  position: absolute;
  top: 550px;
  left: 0px;
  z-index: 999;
}
.item_right{
  width: 222px;
  height: 151px;
  background: url("../static/image/picr.png");
  position: absolute;
  top: 750px;
  right: 0px;
  z-index: 999;
}
</style>

<script>
import cheader from "./components/header";
import cfooter from "./components/footer";

export default {
  name: "App",
  components: {
    cheader,
    cfooter,
  },
  beforeCreate() {
    this.$store.dispatch("menuIndex");
  },
  created() {
  },
  mounted() {
    document.getElementById('app').style.minHeight = window.innerHeight + 'px'
  }
};
</script>



// WEBPACK FOOTER //
// App.vue?4cb3f010